// import {ITokenResponse, IVerifyLoginResponse} from '../../interfaces/IAuth.interfaces';
import {authApi as api} from "./auth-api.service";
import {notification} from "antd";
import {CloseRoundedCheck} from "../../assets/icons/defaultIcons";
import React from "react";

// import {PAGINATION} from '../../config/constants'
export class UserAuthService {
  static storageKey = "RUK_AUTH_TOKEN";

  static async login(data) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.post("auth/login", data, { headers });
    console.log("res", res);
    if (!res?.data?.status) return null;

    if (
      res?.data?.data?.data?.user?.subscription?.length ||
      res?.data?.data?.data?.user?.role?.roleId == 30 ||
      res?.data?.data?.data?.user?.role?.roleId == 40
    ) {
      this.setUserData(res.data?.data?.data?.user);
      this.setToken(res.data?.data?.data?.access_token);
      console.log(res.data?.data?.data?.access_token, "token auth");
      return res?.data?.data;
    } else {
      notification.error({
        message: "Failed",
        description:
          "It appears that your subscription has expired or you haven't subscribed yet",
        placement: "topRight",
        icon: <CloseRoundedCheck />,
        duration: 2,
      });
    }
  }

  static async getProfileData() {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.get("auth/get-profile", { headers });
    return res;
  }
  static async getProfileDataById(id) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.get("auth/get-profile/" + id, { headers });
    return res;
  }
  static async getProfileById(param) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.get("auth/get-profile-by-id", {
      headers,
      params: param,
    });
    return res;
  }

  static async updateProfileData(payload) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.patch("auth/update-profile", payload, { headers });
    return res;
  }

  static async getIndustryData(params) {
    const res = await api.get("industry", params);
    return res;
  }

  static async ValidateJournalPassword(payload) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.post(`auth/validate-journal-password`, payload, {
      headers,
    });
    // this.setToken(res.data?.data?.access_token.token);
    return res;
  }
  static async ResetJournalPassword(payload) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.patch(`auth/set-journal-password`, payload, {
      headers,
    });
    // this.setToken(res.data?.data?.access_token.token);
    return res;
  }

  static async GetPages(slug) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const res = await api.get(`page/${slug}`, { headers });
    // this.setToken(res.data?.data?.access_token.token);
    return res;
  }
  /*
    /**
     * This function will confirm that the user is logged in and if they are not will log them out and
     * redirect to the login screen
     * @returns IVerifyLoginResponse
     */
  /*async index(
      perPage = PAGINATION.perPage,
      page = 1,
      params
    ) {
      const res = await api.get('get-restaurant-users', {
        params: {'per-page': perPage, page, ...params},
      })
      return res.data
    }
    async getById(id) {
      const res = await api.get(`users/${id}`)
      return res.data
    }
    async destroy(id) {
      const res = await api.delete(`users/${id}`)
      return res.data
    }
    async getUser() {
      const res = await api.get('me')
      return res.data
    }
    // Reset Password routes
    async sendEmail(email) {
      const res = await api.post('/api/auth/reset-password-email', {email})
      return res.data
    }*/
  // Token Helpers
  static getToken() {
    const localToken = localStorage.getItem(this.storageKey);
    if (localToken) return localToken;

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    if (token) return token;
  }

  static getUserID() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user)._id : null;
  }
  static getAuthUser() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  }

  static getUserRole() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user)?.role?.name : null;
  }

  static isAuthenticated = () => {
    /*todo: Do Expiry check from token*/
    return !!this.getToken();
  };

  static setToken(token) {
    if (token) localStorage.setItem(this.storageKey, token);
    else localStorage.removeItem(this.storageKey);
  }

  static setUserData(data) {
    if (!data) return localStorage.removeItem("user");
    localStorage.setItem("user", JSON.stringify(data));
  }

  static EmptyLocalStorage() {
    this.setToken(null);
    this.setUserData(null);
    // window.location.assign(`/`);
  }
  static logout() {
    this.setToken(null);
    this.setUserData(null);
    // window.location.assign(`/`);
  }

  static async registerUser(data) {
    const res = await api.post("user/register", data);
    return res.data;
  }

  static async verifyUserAccount(data) {
    const res = await api.post(`user/verify-account`, data);
    // this.setToken(res.data?.data?.access_token.token);
    return res.data;
  }

  static async resendOTP(data) {
    const res = await api.post(`user/resend-otp`, data);
    return res.data;
  }

  static async resendVerificationOTP(data) {
    const res = await api.post(`user/resend-activation-otp`, data);
    return res.data;
  }

  static async ForgetPasswordApi(email) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const response = await api.post(
      "auth/forgot-password",
      { email: email },
      { headers }
    );
    return response;
  }

  static async VerifyOtpApi(otp_code, email) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const response = await api.post(
      "auth/verify-otp",
      { otp: otp_code, email },
      { headers }
    );

    return response;
  }

  static async DeleteUser(payload) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const response = await api.patch("auth/delete-user", payload, { headers });
    if (response) {
      this.setToken(null);
      this.setUserData(null);
    }

    return response;
  }

  static async ResetPasswordApi(email, password, confirmPassword) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };
    const response = await api.patch(
      "auth/reset-password",
      { email, password, confirmPassword },
      { headers }
    );
    return response;
  }

  static async ChangePasswordApi(
    currentPassword,
    newPassword,
    confirmNewPassword
  ) {
    const token = process.env.REACT_APP_AUTH_TOKEN;
    const headers = {
      "x-access-token": token,
    };

    const response = await api.patch(
      "auth/change-password",
      { currentPassword, newPassword, confirmNewPassword },
      { headers }
    );

    return response;
  }

  // async changePassword(payload) {
  //   const res = await api.post("change-password", payload);
  //   return res.data;
  // }
}
